var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.333 14H4.667m6.666 0h.536c.745 0 1.118 0 1.403-.145.25-.128.455-.332.583-.583.145-.285.145-.658.145-1.403V6.146c0-.299 0-.45-.032-.592a1.3 1.3 0 0 0-.14-.363c-.07-.127-.17-.237-.366-.455l-1.837-2.041c-.227-.253-.342-.38-.48-.472a1.3 1.3 0 0 0-.407-.181C10.575 2 10.4 2 10.05 2H4.133c-.746 0-1.12 0-1.405.145-.251.128-.455.332-.583.583C2 3.013 2 3.387 2 4.133v7.734c0 .746 0 1.12.145 1.404.128.251.332.456.583.584.285.145.658.145 1.403.145h.536m6.666 0v-2.536c0-.745 0-1.118-.145-1.403a1.34 1.34 0 0 0-.583-.582c-.285-.146-.658-.146-1.405-.146H6.8c-.747 0-1.12 0-1.405.146-.251.127-.455.331-.583.582-.145.285-.145.659-.145 1.406V14M10 4.667H6"
  })));
};
export { SvgSave as ReactComponent };
export default __webpack_public_path__ + "bbd76cdc0f42a33b32271f6a07959801.svg";